module.exports = __webpack_public_path__ + "img/VideoSeries.b239717c.svg";